module.exports = __webpack_public_path__ + "img/legalServices-3.b2470420.png";